import { categories } from '@/mocks/articles';

interface ArticleContentProps {
  title: string;
  author: string;
  date: string;
  category: string;
  views: number;
  comments: number;
  content: string;
  tags: string[];
}

export default function ArticleContent({ title, author, date, category, views, comments, content, tags }: ArticleContentProps) {
  const catInfo = categories.find((c) => c.id === category);

  return (
    <article className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
      <header className="mb-8">
        <div className="flex items-center gap-3 mb-4 flex-wrap">
          {catInfo && (
            <span className="px-3 py-1 bg-accent-100 text-accent-900 text-xs font-medium rounded-md">
              {catInfo.name}
            </span>
          )}
          <span className="text-sm text-foreground-400">{date}</span>
        </div>

        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug mb-4">
          {title}
        </h1>

        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-1.5 text-sm text-foreground-500">
            <i className="ri-user-line"></i>
            <span>{author}</span>
          </div>
          <div className="flex items-center gap-4 text-sm text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views} 阅读
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {comments} 评论
            </span>
          </div>
        </div>
      </header>

      <div
        className="prose prose-base max-w-none text-foreground-800 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: content }}
      />

      <div className="mt-8 pt-6 border-t border-background-200">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm text-foreground-500">标签：</span>
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 bg-secondary-100 text-secondary-900 text-xs rounded-full"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}